import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import {
  collection,
  doc,
  increment,
  onSnapshot,
  runTransaction,
  updateDoc,
  query,
  where,
  getDocs,
  getDoc,
  serverTimestamp,
} from "firebase/firestore";

import { auth, db } from "../firebase";

function AdminPanel() {
  
  const [activeTab, setActiveTab] = useState("deposit");

  const [depositRequests, setDepositRequests] = useState([]);

  const [withdrawRequests, setWithdrawRequests] = useState([]);
 
useEffect(() => {
  const unsubscribe = onSnapshot(
  collection(db, "withdraws"),
  (snapshot) => {
    const data = snapshot.docs.map((withdrawDoc) => ({
      id: withdrawDoc.id,
      ...withdrawDoc.data(),
    }));

    data.sort((a, b) => {
      const firstTime = a.createdAt?.toMillis
        ? a.createdAt.toMillis()
        : Number(a.createdAtMillis || 0);

      const secondTime = b.createdAt?.toMillis
        ? b.createdAt.toMillis()
        : Number(b.createdAtMillis || 0);

      return secondTime - firstTime;
    });

    setWithdrawRequests(data);
  }
);

  return () => unsubscribe();
}, []);
useEffect(() => {
  const unsubscribeDeposits = onSnapshot(
    collection(db, "deposits"),
    (snapshot) => {
      const data = snapshot.docs.map((depositDoc) => ({
        id: depositDoc.id,
        ...depositDoc.data(),
      }));

      data.sort((a, b) => {
        const firstTime = a.createdAt?.toMillis
          ? a.createdAt.toMillis()
          : Number(a.createdAtMillis || 0);

        const secondTime = b.createdAt?.toMillis
          ? b.createdAt.toMillis()
          : Number(b.createdAtMillis || 0);

        return secondTime - firstTime;
      });

      setDepositRequests(data);
    }
  );

  return () => unsubscribeDeposits();
}, []);
const findReferrerReference = async (userData) => {
  if (!userData) {
    return null;
  }

  if (userData.referredByUid) {
    const directRef = doc(
      db,
      "users",
      userData.referredByUid
    );

    const directSnapshot = await getDoc(directRef);

    if (directSnapshot.exists()) {
      return directRef;
    }
  }

  if (userData.referredBy) {
    const referralQuery = query(
      collection(db, "users"),
      where(
        "referralCode",
        "==",
        String(userData.referredBy)
          .trim()
          .toUpperCase()
      )
    );

    const referralSnapshot =
      await getDocs(referralQuery);

    if (!referralSnapshot.empty) {
      return referralSnapshot.docs[0].ref;
    }
  }

  return null;
};
  const updateDepositStatus = async (id, status) => {
  try {
    const depositRef = doc(db, "deposits", id);

    const depositSnapshot = await getDoc(depositRef);

    if (!depositSnapshot.exists()) {
      alert("Deposit request nahi mili.");
      return;
    }

    const depositData = depositSnapshot.data();

    if (
      status === "Approved" &&
      depositData.status === "Approved"
    ) {
      alert("This deposit is already approved.");
      return;
    }

    const depositorId =
      depositData.userId || depositData.uid;

    if (!depositorId) {
      alert("Deposit user ID missing.");
      return;
    }

    const depositorRef = doc(
      db,
      "users",
      depositorId
    );

    const referralLevels = [];

    if (status === "Approved") {
      const depositorSnapshot =
        await getDoc(depositorRef);

      if (depositorSnapshot.exists()) {
        let currentUserData =
          depositorSnapshot.data();

        const usedReferrerIds = new Set([
          depositorId,
        ]);

        const levelRates = [
          { level: 1, rate: 0.15 },
          { level: 2, rate: 0.05 },
          { level: 3, rate: 0.02 },
        ];

        for (const levelInfo of levelRates) {
          const referrerRef =
            await findReferrerReference(
              currentUserData
            );

          if (!referrerRef) {
            break;
          }

          if (
            usedReferrerIds.has(referrerRef.id)
          ) {
            console.warn(
              "Circular referral chain stopped:",
              referrerRef.id
            );

            break;
          }

          const referrerSnapshot =
            await getDoc(referrerRef);

          if (!referrerSnapshot.exists()) {
            break;
          }

          usedReferrerIds.add(referrerRef.id);

          referralLevels.push({
            ref: referrerRef,
            level: levelInfo.level,
            rate: levelInfo.rate,
          });

          currentUserData =
            referrerSnapshot.data();
        }
      }
    }
console.log(
  "REFERRAL LEVELS FOUND:",
  referralLevels.map((item) => ({
    uid: item.ref.id,
    level: item.level,
    rate: item.rate,
  }))
);
    await runTransaction(
      db,
      async (transaction) => {
        const latestDepositSnapshot =
          await transaction.get(depositRef);

        if (!latestDepositSnapshot.exists()) {
          throw new Error(
            "Deposit request nahi mili."
          );
        }

        const latestDepositData =
          latestDepositSnapshot.data();

        if (
          status === "Approved" &&
          latestDepositData.status === "Approved"
        ) {
          throw new Error(
            "This deposit is already approved."
          );
        }

        let depositorSnapshot = null;
        const referrerSnapshots = [];

        if (
          status === "Approved" &&
          latestDepositData.status !== "Approved"
        ) {
          depositorSnapshot =
            await transaction.get(depositorRef);

          for (const referralLevel of referralLevels) {
            const referrerSnapshot =
              await transaction.get(
                referralLevel.ref
              );

            referrerSnapshots.push({
              ...referralLevel,
              snapshot: referrerSnapshot,
            });
          }
        }

        if (
          status === "Approved" &&
          latestDepositData.status !== "Approved"
        ) {
          const depositAmount = Number(
            latestDepositData.amount || 0
          );

          if (
            !Number.isFinite(depositAmount) ||
            depositAmount <= 0
          ) {
            throw new Error(
              "Invalid deposit amount."
            );
          }

          transaction.update(depositRef, {
            status: "Approved",
            approvedAt: serverTimestamp(),
          });

          if (depositorSnapshot?.exists()) {
            transaction.update(depositorRef, {
              balance: increment(depositAmount),
              totalDeposit:
                increment(depositAmount),
            });
          } else {
            throw new Error(
              "Deposit user not found."
            );
          }

          for (const referralData of referrerSnapshots) {
            if (!referralData.snapshot.exists()) {
              continue;
            }

            const referralBonus =
              depositAmount *
              referralData.rate;

            transaction.update(
              referralData.ref,
              {
                balance:
                  increment(referralBonus),

                referralCommission:
                  increment(referralBonus),
              }
            );
          }
        } else {
          transaction.update(depositRef, {
            status,
            updatedAt: serverTimestamp(),
          });
        }
      }
    );

    alert("Status Updated Successfully!");
  } catch (error) {
    console.error(
      "Deposit status error:",
      error
    );

    alert(
      error.message ||
        "Error updating status"
    );
  }
};
const updateWithdrawStatus = async (id, status) => {
  try {
    await runTransaction(db, async (transaction) => {
      const withdrawRef = doc(db, "withdraws", id);
      const withdrawSnap = await transaction.get(withdrawRef);

      if (!withdrawSnap.exists()) {
        throw new Error("Withdraw request not found.");
      }

      const withdrawData = withdrawSnap.data();

      if (
        status === "Approved" &&
        withdrawData.status === "Approved"
      ) {
        throw new Error("This withdraw is already approved.");
      }

      const userId = withdrawData.uid || withdrawData.userId;

      if (!userId) {
        throw new Error("User ID missing.");
      }

      const userRef = doc(db, "users", userId);
      const userSnap = await transaction.get(userRef);

      if (!userSnap.exists()) {
        throw new Error("User not found.");
      }

      const userData = userSnap.data();
      const withdrawAmount = Number(withdrawData.amount || 0);
      const currentProfit = Number(userData.totalProfit || 0);

      if (status === "Approved") {
        const currentBalance = Number(userData.balance || 0);

        if (currentBalance < withdrawAmount) {
          throw new Error("User balance is insufficient.");
        }

        transaction.update(userRef, {
          balance: currentBalance - withdrawAmount,
          totalWithdraw:
            Number(userData.totalWithdraw || 0) + withdrawAmount,
        });
      }

      transaction.update(withdrawRef, {
        status,
        updatedAt: serverTimestamp(),
      });
    });

    alert(`Withdraw ${status.toLowerCase()} successfully.`);
  } catch (error) {
    console.error("Withdraw status error:", error);
    alert(error.message);
  }
};

  

  return (
    <div className="app admin-page">
      <header className="page-header">
        <Link to="/dashboard" className="back-button">
          ←
        </Link>

        <div>
          <h1>Admin Panel</h1>
          <p>Manage deposit and withdraw requests</p>
        </div>
      </header>

      <section className="admin-summary-grid">
        <div className="admin-summary-card">
          <span>Pending Deposits</span>
          <strong>
            {
              depositRequests.filter(
                (request) => request.status === "Pending"
              ).length
            }
          </strong>
        </div>

        <div className="admin-summary-card">
          <span>Pending Withdraws</span>
          <strong>
            {
              withdrawRequests.filter(
                (request) => request.status === "Pending"
              ).length
            }
          </strong>
        </div>
      </section>

      <section className="admin-tab-card">
        <button
          type="button"
          className={activeTab === "deposit" ? "admin-tab active" : "admin-tab"}
          onClick={() => setActiveTab("deposit")}
        >
          Deposits
        </button>

        <button
          type="button"
          className={activeTab === "withdraw" ? "admin-tab active" : "admin-tab"}
          onClick={() => setActiveTab("withdraw")}
        >
          Withdraws
        </button>
      </section>

      {activeTab === "deposit" ? (
        <section className="admin-request-list">
          {depositRequests.map((request) => (
            <article className="admin-request-card" key={request.id}>
              <div className="admin-request-header">
                <div>
                  <h3>{request.userEmail || "No Email"}</h3>
                  <span>{request.method}</span>
                </div>

                <strong>${request.amount.toFixed(2)}</strong>
              </div>

              <div className="admin-request-details">
                <p>
                  <span>TXID</span>
                  <strong>{request.txid}</strong>
                </p>

                <p>
                  <span>Date</span>
                  <strong>
  {request.createdAt?.toDate
    ? request.createdAt.toDate().toLocaleDateString("en-GB")
    : "No Date"}
</strong>
                </p>

                <p>
                  <span>Status</span>
                  <strong className={`admin-status ${request.status.toLowerCase()}`}>
                    {request.status}
                  </strong>
                </p>
              </div>

              <div className="admin-action-buttons">
                <button
                  type="button"
                  className="approve-button"
                  onClick={() => updateDepositStatus(request.id, "Approved")}
                >
                  Approve
                </button>

                <button
                  type="button"
                  className="reject-button"
                  onClick={() => updateDepositStatus(request.id, "Rejected")}
                >
                  Reject
                </button>

                <button
                  type="button"
                  className="pending-button"
                  onClick={() => updateDepositStatus(request.id, "Pending")}
                >
                  Pending
                </button>
              </div>
            </article>
          ))}
        </section>
      ) : (
        <section className="admin-request-list">
          {withdrawRequests.map((request) => (
            <article className="admin-request-card" key={request.id}>
              <div className="admin-request-header">
                <div>
                 <h3>{request.userEmail || request.email || "SnapTube User"}</h3>
                  <span>{request.method}</span>
                </div>

                <strong>${request.amount.toFixed(2)}</strong>
              </div>

              <div className="admin-request-details">
                <p>
                  <span>
  {request.walletAddress || request.wallet
    ? "BEP20 Address"
    : "JazzCash Number"}
</span>
                  <strong>
  {request.walletAddress ||
    request.wallet ||
    request.accountNumber ||
    "No Account Details"}
</strong>
                </p>

                <p>
                  <span>Date</span>
                 <strong>
  {request.date ||
    (request.createdAt?.toDate
      ? request.createdAt.toDate().toLocaleDateString("en-GB")
      : "No Date")}
</strong>
                </p>

                <p>
                  <span>Status</span>
                  <strong className={`admin-status ${request.status.toLowerCase()}`}>
                    {request.status}
                  </strong>
                </p>
              </div>

              <div className="admin-action-buttons">
                <button
                  type="button"
                  className="approve-button"
                  onClick={() => updateWithdrawStatus(request.id, "Approved")}
                >
                  Approve
                </button>

                <button
                  type="button"
                  className="reject-button"
                  onClick={() => updateWithdrawStatus(request.id, "Rejected")}
                >
                  Reject
                </button>

                <button
                  type="button"
                  className="pending-button"
                  onClick={() => updateWithdrawStatus(request.id, "Pending")}
                >
                  Pending
                </button>
              </div>
            </article>
          ))}
        </section>
      )}
    </div>
  );
}

export default AdminPanel;